<div class="rx-profile-content t-scrollbar">
  <div class="opt-container" *ngIf="options.length">
    <div *ngFor="let opt of options" class="opt">
      <rx-opt-display [opt]="opt" [drProfileSw]="true"></rx-opt-display>
    </div>
  </div>

  <div class="notes">
    <div *ngFor="let note of notes; let i = index">
      <input-wrap
        *ngIf="!note.presetNoteId"
        label="{{ 'translate.mng.note' | translate }}"
        cssClass="l-cell-spread w-full"
      >
        <textarea
          dir="auto"
          class="t-input t-input--colored"
          [(ngModel)]="notes[i].text"
        ></textarea>
      </input-wrap>

      <div *ngIf="note.presetNoteId" class="fixed-note">
        <p>{{ note.text }}</p>
        <a (click)="clearNote(note)">
          <img src="assets\img\clear_input.svg"
        /></a>
      </div>
    </div>

    <a (click)="addFixedNoteOpenSw = true">+ הוספת הערה מבנק הערות</a>
  </div>
</div>

<select-fixed-note
  *ngIf="addFixedNoteOpenSw"
  (onClose)="onFixedNoteClose($event)"
  [preselectedNotes]="notes"
  [profileId]="profile?.profileId"
></select-fixed-note>
